$(document).ready(function() {

  $(".filtered-posts--load-more-a").on('click',function(e) {
    e.preventDefault();
    var paged = parseFloat( $(this).attr('data-next') );
    var exclude = $(this).attr('data-exclude');
    var include = $(this).attr('data-include');
    updatePostsResults(paged, exclude, include);
  });

	var updatePostsResults = function( paged, exclude, include ) {

    paged            = paged ? paged : 1;
    var grid         = $('.filtered-posts--content');;

    $.ajax({
      type     : "post",
      dataType : "json",
      url      : localized_object.ajax_url,
      data : {
        action : "get_posts_form",
        data   : {'paged' : paged,'exclude' : exclude, 'include' : include},
        nonce  : localized_object.nonce,
        paged  : paged
      },
      timeout    : 300000,
      beforeSend : function() {

      }
    }).done( function( response ) {

      if ( response && typeof response.news !== 'undefined' ) {

       	var count = $('.cur-num').text();
        count = parseFloat(count) + parseFloat(response.displaying);

        var newPosts = $( response.news );
        grid.append(newPosts);

        $(".filtered-posts--load-more").attr('data-next', response.cur_page + 1 );
        $('.cur-num').html(count);
        $('.max-num').html(parseFloat(response.max_count));

        if ( response.cur_page < response.max_pages ) {
          $(".filtered-posts--load-more").show();
        } else {
          $(".filtered-posts--load-more").hide();
        }

		  }

    }).fail( function( request, status, err ) {

       console.log( 'REQUEST => ' + request );
       console.log( 'STATUS => ' + status );
       console.log( 'ERR => ' );
       console.log( err );

    }).always(function() {



    });

  }

});
